export default "__VITE_ASSET__BDMTBM0c__"